export const DEVICE_PRESETS = [
    // 1. Arturia AudioFuse 16Rig
    {
        name: 'Arturia AudioFuse 16Rig',
        type: 'USB Audio Interface',
        category: 'interface',
        manufacturer: 'Arturia',
        inputs: [
            {
                name: 'Line In 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 5',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 6',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 7',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 8',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 9',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 10',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 11',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 12',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 13',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 14',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 15',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 16',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Mic/Line Combo 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
                notes: 'with preamps',
            },
            {
                name: 'Mic/Line Combo 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
                notes: 'with preamps',
            },
            {
                name: 'Front Instrument/Line 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Front Instrument/Line 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'ADAT In 1',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'ADAT In 2',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'Word Clock In',
                type: 'input',
                signalType: 'word_clock',
                connectorFormat: 'BNC',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'from computer',
            },
        ],
        outputs: [
            {
                name: 'Line Out 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 5',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 6',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 7',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 8',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Front Panel Out 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Front Panel Out 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Speaker Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Speaker Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'ADAT Out 1',
                type: 'output',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'ADAT Out 2',
                type: 'output',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'MIDI Out 1',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 2/Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'Word Clock Out',
                type: 'output',
                signalType: 'word_clock',
                connectorFormat: 'BNC',
            },
        ],
    },
    // 2. Arturia AudioFuse X8 IN
    {
        name: 'Arturia AudioFuse X8 IN',
        type: 'ADAT Input Expander',
        category: 'interface',
        manufacturer: 'Arturia',
        inputs: [
            {
                name: 'Line In 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 5',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 6',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 7',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 8',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
        ],
        outputs: [
            {
                name: 'ADAT Out',
                type: 'output',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
        ],
    },
    // 3. Arturia AudioFuse X8 OUT
    {
        name: 'Arturia AudioFuse X8 OUT',
        type: 'ADAT Output Expander',
        category: 'interface',
        manufacturer: 'Arturia',
        inputs: [
            {
                name: 'ADAT In',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
        ],
        outputs: [
            {
                name: 'Line Out 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 5',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 6',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 7',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 8',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
        ],
    },
    // 4. Mackie 2404 VLZ4
    {
        name: 'Mackie 2404 VLZ4',
        type: '24-Channel 4-Bus Analog Mixer',
        category: 'mixer',
        manufacturer: 'Mackie',
        inputs: [
            {
                name: 'Mic/Line 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 5',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 6',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 7',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 8',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 9',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 10',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 11',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 12',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 13',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 14',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 15',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 16',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Line 17 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo ch 17/18',
            },
            {
                name: 'Line 18 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo ch 17/18',
            },
            {
                name: 'Line 19 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo ch 19/20',
            },
            {
                name: 'Line 20 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo ch 19/20',
            },
            {
                name: 'Line 21 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo ch 21/22',
            },
            {
                name: 'Line 22 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo ch 21/22',
            },
            {
                name: 'Line 23 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo ch 23/24',
            },
            {
                name: 'Line 24 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo ch 23/24',
            },
            {
                name: 'Aux Return 1 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Return 1 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Return 2 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Return 2 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Return 3 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Return 3 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Return 4 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Return 4 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: '2-Track In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: '2-Track In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'USB In',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
                channels: 2,
            },
        ],
        outputs: [
            {
                name: 'Main Out L (XLR)',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                exclusiveGroup: 'main-out-l',
            },
            {
                name: 'Main Out R (XLR)',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                exclusiveGroup: 'main-out-r',
            },
            {
                name: 'Main Out L (TRS)',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'alt connector — parallel with XLR',
                exclusiveGroup: 'main-out-l',
            },
            {
                name: 'Main Out R (TRS)',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'alt connector — parallel with XLR',
                exclusiveGroup: 'main-out-r',
            },
            {
                name: 'Sub 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Sub 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Sub 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Sub 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send 5',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send 6',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Control Room L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Control Room R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: '2-Track Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: '2-Track Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'USB Out',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
                channels: 2,
            },
        ],
    },
    // 5. iConnectivity mioXL
    {
        name: 'iConnectivity mioXL',
        type: 'MIDI Interface/Router',
        category: 'midi_interface',
        manufacturer: 'iConnectivity',
        inputs: [
            {
                name: 'MIDI In 1',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 2',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 3',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 4',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 5',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 6',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 7',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 8',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB MIDI Host 1',
                type: 'input',
                signalType: 'midi',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB MIDI Host 2',
                type: 'input',
                signalType: 'midi',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB MIDI Host 3',
                type: 'input',
                signalType: 'midi',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB MIDI Host 4',
                type: 'input',
                signalType: 'midi',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB MIDI Host 5',
                type: 'input',
                signalType: 'midi',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB MIDI Host 6',
                type: 'input',
                signalType: 'midi',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB MIDI Host 7',
                type: 'input',
                signalType: 'midi',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB MIDI Host 8',
                type: 'input',
                signalType: 'midi',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB MIDI Host 9',
                type: 'input',
                signalType: 'midi',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB MIDI Host 10',
                type: 'input',
                signalType: 'midi',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB Device',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
                notes: 'from computer',
            },
            {
                name: 'Ethernet',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
            },
        ],
        outputs: [
            {
                name: 'MIDI Out 1',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 2',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 3',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 4',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 5',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 6',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 7',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 8',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 9',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 10',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 11',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 12',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // 6. Moog Messenger
    {
        name: 'Moog Messenger',
        type: 'Monophonic Analog Synthesizer',
        category: 'synth',
        manufacturer: 'Moog',
        inputs: [
            {
                name: 'Ext Audio In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
                notes: 'to filter',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'CV In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Gate In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Clock In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Expression',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'expression pedal',
            },
            {
                name: 'Sustain',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'sustain pedal',
            },
        ],
        outputs: [
            {
                name: 'Audio Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Headphones',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CV Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Gate Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Clock Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // 7. ASM Hydrasynth 49
    {
        name: 'ASM Hydrasynth 49',
        type: '8-Voice Polyphonic Wave Morphing Synthesizer',
        category: 'synth',
        manufacturer: 'ASM',
        inputs: [
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
            {
                name: 'CV In 1',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV In 2',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Expression',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'expression pedal',
            },
            {
                name: 'Sustain',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'sustain pedal',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'balanced',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'balanced',
            },
            {
                name: 'Headphones',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'CV Out 1',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV Out 2',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV Out 3',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV Out 4',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV Out 5',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
        ],
    },
    // 8. Oberheim TEO-5
    {
        name: 'Oberheim TEO-5',
        type: '5-Voice Polyphonic Analog Synthesizer',
        category: 'synth',
        manufacturer: 'Oberheim',
        inputs: [
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
            {
                name: 'Pedal In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'footswitch',
            },
            {
                name: 'Expression In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'expression pedal',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphones',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // 9. Modal Electronics Carbon 8M
    {
        name: 'Modal Electronics Carbon 8M',
        type: '8-Voice Digital Desktop Synthesizer',
        category: 'synth',
        manufacturer: 'Modal Electronics',
        inputs: [
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Sustain In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'sustain pedal',
            },
            {
                name: 'Expression In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'expression pedal',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphones',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    // 10. Pittsburgh Modular Taiga
    {
        name: 'Pittsburgh Modular Taiga',
        type: 'Semi-Modular Paraphonic Synthesizer',
        category: 'semi_modular',
        manufacturer: 'Pittsburgh Modular',
        inputs: [
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'Patch Bay In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
                channels: 30,
                notes: '60-point patch bay, 30 inputs',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'Patch Bay Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
                channels: 30,
                notes: '60-point patch bay, 30 outputs',
            },
        ],
    },
    // 11. Telepathic Instruments Orchid ORC-1
    {
        name: 'Telepathic Instruments Orchid ORC-1',
        type: '16-Voice Polyphonic Chord Synthesizer',
        category: 'synth',
        manufacturer: 'Telepathic Instruments',
        inputs: [
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'MIDI input via USB only',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'headphone/line — stereo on single 3.5mm TRS jack, splits via Y-cable',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'headphone/line — stereo on single 3.5mm TRS jack, splits via Y-cable',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // 12. Roland TR-8S
    {
        name: 'Roland TR-8S',
        type: 'Rhythm Performer',
        category: 'drum_machine',
        manufacturer: 'Roland',
        inputs: [
            {
                name: 'Ext In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Ext In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
                notes: 'multichannel audio + MIDI',
            },
        ],
        outputs: [
            {
                name: 'Main Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Main Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Assignable Out 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'switchable to trigger mode',
            },
            {
                name: 'Assignable Out 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'switchable to trigger mode',
            },
            {
                name: 'Assignable Out 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'switchable to trigger mode',
            },
            {
                name: 'Assignable Out 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'switchable to trigger mode',
            },
            {
                name: 'Assignable Out 5',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'switchable to trigger mode',
            },
            {
                name: 'Assignable Out 6',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'switchable to trigger mode',
            },
            {
                name: 'Trigger Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphones',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // 13. Roland SP-404MKII
    {
        name: 'Roland SP-404MKII',
        type: 'Creative Sampler',
        category: 'sampler',
        manufacturer: 'Roland',
        inputs: [
            {
                name: 'Line In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Mic/Guitar In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'audio + MIDI + file transfer',
            },
        ],
        outputs: [
            {
                name: 'Line Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphones 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphones 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
        ],
    },
    // 14. Teenage Engineering EP-40 Riddim
    {
        name: 'Teenage Engineering EP-40 Riddim',
        type: 'Supertone Layering Machine',
        category: 'sampler',
        manufacturer: 'Teenage Engineering',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'power + sample transfer',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    // 15. AKAI MPC X Special Edition
    {
        name: 'AKAI MPC X Special Edition',
        type: 'Standalone Music Production Center',
        category: 'sampler',
        manufacturer: 'AKAI',
        inputs: [
            {
                name: 'Input 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
                notes: '+48V phantom power',
            },
            {
                name: 'Input 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
                notes: '+48V phantom power',
            },
            {
                name: 'Input 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Input 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Phono In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Phono In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Instrument In 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
                notes: 'front panel',
            },
            {
                name: 'Instrument In 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
                notes: 'front panel',
            },
            {
                name: 'MIDI In 1',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 2',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
                notes: 'USB 3.0 to computer',
            },
            {
                name: 'Footswitch 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'footswitch',
            },
            {
                name: 'Footswitch 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'footswitch',
            },
        ],
        outputs: [
            {
                name: 'Output 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Output 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Output 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Output 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Output 5',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Output 6',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Output 7',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Output 8',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphones (1/4")',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphones (3.5mm)',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'front panel',
            },
            {
                name: 'MIDI Out 1',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 2',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 3',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 4',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'CV/Gate 1',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
                notes: '0-5V',
            },
            {
                name: 'CV/Gate 2',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
                notes: '0-5V',
            },
            {
                name: 'CV/Gate 3',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
                notes: '0-5V',
            },
            {
                name: 'CV/Gate 4',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
                notes: '0-5V',
            },
            {
                name: 'CV/Gate 5',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
                notes: '0-5V',
            },
            {
                name: 'CV/Gate 6',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
                notes: '0-5V',
            },
            {
                name: 'CV/Gate 7',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
                notes: '0-5V',
            },
            {
                name: 'CV/Gate 8',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
                notes: '0-5V',
            },
        ],
    },
    // 16. Roland AIRA Compact E-4
    {
        name: 'Roland AIRA Compact E-4',
        type: 'Voice Tweaker',
        category: 'groovebox',
        manufacturer: 'Roland',
        inputs: [
            {
                name: 'Mic In (built-in)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'built-in mic',
            },
            {
                name: 'Mix In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Mix In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Mix Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Mix Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    // 17. Roland AIRA Compact J-6
    {
        name: 'Roland AIRA Compact J-6',
        type: 'Chord Synthesizer',
        category: 'groovebox',
        manufacturer: 'Roland',
        inputs: [
            {
                name: 'Mix In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Mix In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Mix Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Mix Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    // 18. Roland AIRA Compact S-1
    {
        name: 'Roland AIRA Compact S-1',
        type: 'Tweak Synth',
        category: 'groovebox',
        manufacturer: 'Roland',
        inputs: [
            {
                name: 'Mix In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Mix In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Mix Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Mix Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    // 19. Roland AIRA Compact P-6
    {
        name: 'Roland AIRA Compact P-6',
        type: 'Creative Sampler',
        category: 'groovebox',
        manufacturer: 'Roland',
        inputs: [
            {
                name: 'Mic In (built-in)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'built-in mic',
            },
            {
                name: 'Mix In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Mix In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Mix Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Mix Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    // 20. Ableton Push 3
    {
        name: 'Ableton Push 3',
        type: 'Standalone Controller / Audio Interface',
        category: 'controller',
        manufacturer: 'Ableton',
        inputs: [
            {
                name: 'Audio In 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'switchable line/instrument',
            },
            {
                name: 'Audio In 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'switchable line/instrument',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
            {
                name: 'USB-C',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'controller mode to computer',
            },
            {
                name: 'ADAT In',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'Pedal/CV 1',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TRS',
                notes: 'dual-purpose footswitch or CV',
            },
            {
                name: 'Pedal/CV 2',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TRS',
                notes: 'dual-purpose footswitch or CV',
            },
        ],
        outputs: [
            {
                name: 'Audio Out 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'balanced',
            },
            {
                name: 'Audio Out 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'balanced',
            },
            {
                name: 'Headphones',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
        ],
    },
    // 21. Melbourne Instruments Roto-Control
    {
        name: 'Melbourne Instruments Roto-Control',
        type: 'Motorized MIDI Controller',
        category: 'controller',
        manufacturer: 'Melbourne Instruments',
        inputs: [
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB 1',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'data + power',
            },
            {
                name: 'USB 2',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'data + power',
            },
        ],
        outputs: [
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // 22. PreSonus Atom SQ
    {
        name: 'PreSonus Atom SQ',
        type: 'Hybrid MIDI Pad/Keyboard Controller',
        category: 'controller',
        manufacturer: 'PreSonus',
        inputs: [
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'bus-powered, MIDI',
            },
        ],
        outputs: [
            {
                name: 'USB MIDI Out',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'to computer',
            },
        ],
    },
    // 23. Eventide H90
    {
        name: 'Eventide H90',
        type: 'Multi-Effects Harmonizer',
        category: 'effects',
        manufacturer: 'Eventide',
        inputs: [
            {
                name: 'Audio In 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio In 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio In 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio In 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'Exp/Ctl 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'expression pedal',
            },
            {
                name: 'Exp/Ctl 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'expression pedal/aux switch',
            },
        ],
        outputs: [
            {
                name: 'Audio Out 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI Out/Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // 24. Hologram Microcosm
    {
        name: 'Hologram Microcosm',
        type: 'Granular Looper/Glitch',
        category: 'effects',
        manufacturer: 'Hologram Electronics',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo unbalanced — shares single TRS jack with R (Y-cable)',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo unbalanced — shares single TRS jack with L (Y-cable)',
            },
            {
                name: 'Expression In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'expression pedal',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI Out/Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // 25. Hologram Infinite Jets
    {
        name: 'Hologram Infinite Jets',
        type: 'Resynthesizer',
        category: 'effects',
        manufacturer: 'Hologram Electronics',
        inputs: [
            {
                name: 'Audio In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Expression In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'expression pedal',
            },
        ],
        outputs: [
            {
                name: 'Audio Out A',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out B',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
        ],
    },
    // 26. Hologram Dream Sequence
    {
        name: 'Hologram Dream Sequence',
        type: 'Rhythmic Pitch Shifter',
        category: 'effects',
        manufacturer: 'Hologram Electronics',
        inputs: [
            {
                name: 'Audio In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Expression In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'expression pedal',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
        outputs: [
            {
                name: 'Audio Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI Out/Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // 27. Hologram Chroma Console
    {
        name: 'Hologram Chroma Console',
        type: 'Multi-Effects Console',
        category: 'effects',
        manufacturer: 'Hologram Electronics',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Expression In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'expression pedal',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'MIDI + 24-bit audio',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI Out/Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // 28. ADAM Audio A8H
    {
        name: 'ADAM Audio A8H',
        type: 'Active 3-Way Studio Monitor',
        category: 'monitoring',
        manufacturer: 'ADAM Audio',
        inputs: [
            {
                name: 'Audio In (XLR)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced',
            },
            {
                name: 'Audio In (RCA)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
                notes: 'unbalanced alt',
            },
            {
                name: 'Ethernet',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                notes: 'A Control remote',
            },
        ],
        outputs: [],
    },
    // 29. ADAM Sub12
    {
        name: 'ADAM Sub12',
        type: 'Active Studio Subwoofer',
        category: 'monitoring',
        manufacturer: 'ADAM Audio',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced',
            },
        ],
        outputs: [
            {
                name: 'Audio Thru L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'to satellites',
            },
            {
                name: 'Audio Thru R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'to satellites',
            },
        ],
    },
    // 30. Avantone MixCubes
    {
        name: 'Avantone MixCubes',
        type: 'Near-Field Reference Monitor',
        category: 'monitoring',
        manufacturer: 'Avantone',
        inputs: [
            {
                name: 'Audio In (TRS)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Audio In (XLR)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
        ],
        outputs: [],
    },
    // 31. Mackie Big Knob Passive
    {
        name: 'Mackie Big Knob Passive',
        type: 'Passive Monitor Controller',
        category: 'monitoring',
        manufacturer: 'Mackie',
        inputs: [
            {
                name: 'Source A L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Source A R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Source B L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                exclusiveGroup: 'source-b-l',
            },
            {
                name: 'Source B R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                exclusiveGroup: 'source-b-r',
            },
            {
                name: 'Source B L (3.5mm)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'alt input — parallel with 1/4" TRS',
                exclusiveGroup: 'source-b-l',
            },
            {
                name: 'Source B R (3.5mm)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                exclusiveGroup: 'source-b-r',
                notes: 'alt input',
            },
        ],
        outputs: [
            {
                name: 'Monitor A L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Monitor A R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Monitor B L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Monitor B R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
        ],
    },
    // 32. Black Lion Audio LS-4
    {
        name: 'Black Lion Audio LS-4',
        type: 'Passive 4-Channel Stereo Line Selector',
        category: 'effects',
        manufacturer: 'Black Lion Audio',
        inputs: [
            {
                name: 'In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'balanced stereo input',
            },
            {
                name: 'In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'balanced stereo input',
            },
        ],
        outputs: [
            {
                name: 'A L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'A R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'B L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'B R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'C L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'C R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'D L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'D R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
        ],
    },
    // 33. Apple iPad Pro (with USB-C + 3.5mm adapter)
    {
        name: 'Apple iPad Pro',
        type: 'Tablet / DAW Host',
        category: 'computer',
        manufacturer: 'Apple',
        inputs: [
            {
                name: 'USB-C',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'USB audio/MIDI host, charging',
            },
            {
                name: '3.5mm Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'via USB-C to 3.5mm adapter — stereo on single jack, splits via Y-cable',
            },
            {
                name: '3.5mm Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'via USB-C to 3.5mm adapter — stereo on single jack, splits via Y-cable',
            },
        ],
        outputs: [
            {
                name: 'USB-C',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'USB audio/MIDI host',
            },
            {
                name: '3.5mm Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'via USB-C to 3.5mm adapter — stereo on single jack, splits via Y-cable',
            },
            {
                name: '3.5mm Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'via USB-C to 3.5mm adapter — stereo on single jack, splits via Y-cable',
            },
        ],
    },
    // 34. Teenage Engineering EP-133 KO II
    {
        name: 'Teenage Engineering EP-133 KO II',
        type: 'Sampler / Drum Machine',
        category: 'sampler',
        manufacturer: 'Teenage Engineering',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A, requires adapter for 5-pin DIN',
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
                notes: '8th/16th/24 PPQN, max 10V',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'MIDI + sample transfer (no audio-over-USB)',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A, 3.3V',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
                notes: '8th/16th/24 PPQN, 3.3V',
            },
        ],
    },
    // 35. Teenage Engineering EP-1320 Ting
    {
        name: 'Teenage Engineering EP-1320 Ting',
        type: 'Medieval Drum Machine',
        category: 'drum_machine',
        manufacturer: 'Teenage Engineering',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRRS jack — splits via Y-cable',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRRS jack — splits via Y-cable',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'MIDI + power',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRRS jack — splits via Y-cable',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRRS jack — splits via Y-cable',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    // 36. ADAM Audio D3V
    {
        name: 'ADAM Audio D3V',
        type: 'Desktop Monitor Speaker',
        category: 'monitoring',
        manufacturer: 'ADAM Audio',
        inputs: [
            {
                name: 'Line In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'balanced, +9 dBu max',
            },
            {
                name: 'Line In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'balanced, +9 dBu max',
            },
            {
                name: 'USB Audio In',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'class-compliant USB audio, 24-bit/48kHz',
            },
        ],
        outputs: [
            {
                name: 'Headphone Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'headphone output on primary speaker',
            },
        ],
    },
    // 37. Yamaha AG08
    {
        name: 'Yamaha AG08',
        type: 'Streaming Mixer / USB Interface',
        category: 'mixer',
        manufacturer: 'Yamaha',
        inputs: [
            {
                name: 'CH 1 Mic',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
                notes: 'mono, mic level',
            },
            {
                name: 'CH 2 Mic/Inst',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
                notes: 'mono, mic/line, hi-Z instrument',
            },
            {
                name: 'CH 3 Line L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'line level',
            },
            {
                name: 'CH 4 Line R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'line level',
            },
            {
                name: 'CH 5 Line L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
                notes: 'line level (shared with 3.5mm)',
            },
            {
                name: 'CH 6 Line R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
                notes: 'line level (shared with 3.5mm)',
            },
            {
                name: 'CH 7/8 Aux L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'TRRS, smartphone/aux — stereo on single jack',
            },
            {
                name: 'CH 7/8 Aux R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'TRRS, smartphone/aux — stereo on single jack',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: '24-bit/48kHz multitrack recording/playback',
            },
        ],
        outputs: [
            {
                name: 'Main Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'main stereo mix',
            },
            {
                name: 'Main Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'main stereo mix',
            },
            {
                name: 'Monitor Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced monitor',
                exclusiveGroup: 'monitor-out-l',
            },
            {
                name: 'Monitor Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced monitor',
                exclusiveGroup: 'monitor-out-r',
            },
            {
                name: 'Monitor Out TRS L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'balanced monitor — parallel with XLR',
                exclusiveGroup: 'monitor-out-l',
            },
            {
                name: 'Monitor Out TRS R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'balanced monitor — parallel with XLR',
                exclusiveGroup: 'monitor-out-r',
            },
            {
                name: 'Headphone 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo headphone',
            },
            {
                name: 'Headphone 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo headphone',
            },
        ],
    },
    // 38. Pioneer DJ XDJ-XZ
    {
        name: 'Pioneer DJ XDJ-XZ',
        type: 'All-in-One DJ System',
        category: 'controller',
        manufacturer: 'Pioneer DJ',
        inputs: [
            {
                name: 'CH 3/4 Line L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
                notes: 'line level',
            },
            {
                name: 'CH 3/4 Line R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
                notes: 'line level',
            },
            {
                name: 'CH 3/4 Phono L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
                notes: 'phono level (turntable)',
            },
            {
                name: 'CH 3/4 Phono R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
                notes: 'phono level (turntable)',
            },
            {
                name: 'AUX L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'AUX R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Mic 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'USB-A 1',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
                notes: 'USB media playback',
            },
            {
                name: 'USB-A 2',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
                notes: 'USB media playback',
            },
            {
                name: 'USB-B (PC)',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
                notes: 'laptop connection for DJ software',
            },
            {
                name: 'Pro DJ Link 1',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                notes: 'CDJ/equipment linking',
            },
            {
                name: 'Pro DJ Link 2',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                notes: 'CDJ/equipment linking',
            },
            {
                name: 'Pro DJ Link 3',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                notes: 'CDJ/equipment linking',
            },
        ],
        outputs: [
            {
                name: 'Master Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced',
                exclusiveGroup: 'master-out-l',
            },
            {
                name: 'Master Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced',
                exclusiveGroup: 'master-out-r',
            },
            {
                name: 'Master Out 2 L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
                notes: 'unbalanced — parallel with XLR master',
                exclusiveGroup: 'master-out-l',
            },
            {
                name: 'Master Out 2 R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
                notes: 'unbalanced — parallel with XLR master',
                exclusiveGroup: 'master-out-r',
            },
            {
                name: 'Booth Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Booth Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Send L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Send R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                notes: 'stereo headphone',
            },
            {
                name: 'Headphone 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo headphone',
            },
        ],
    },
    // 39. CHOMPI Club CHOMPI
    {
        name: 'CHOMPI Club CHOMPI',
        type: 'Portable Sampler / Looper',
        category: 'sampler',
        manufacturer: 'CHOMPI Club',
        inputs: [
            {
                name: 'Aux In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Aux In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'power + MIDI',
            },
        ],
        outputs: [
            {
                name: 'Line Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Line Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Headphone Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo headphone',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
        ],
    },
    // 40. Pocket Audio HiChord
    {
        name: 'Pocket Audio HiChord',
        type: 'Pocket Chord Synthesizer',
        category: 'synth',
        manufacturer: 'Pocket Audio',
        inputs: [
            {
                name: 'USB-C',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'USB audio + MIDI + charging',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A (Batch 4+)',
            },
        ],
    },
    // 41. Teenage Engineering OP-Z
    {
        name: 'Teenage Engineering OP-Z',
        type: '16-Track Sequencer / Synthesizer',
        category: 'groovebox',
        manufacturer: 'Teenage Engineering',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'power + data + MIDI',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'stereo on single 3.5mm TRS jack — splits via Y-cable',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
        ],
    },
    // ── Computers & laptops ─────────────────────────────────────────
    //
    // Computer presets are a starting point, not a final answer. The
    // exact port mix on any computer varies with model year, dock,
    // and dongles in use, so these are seeded with the typical
    // out-of-the-box ports and users are expected to open Edit Device
    // and add/remove ports to match their setup (e.g. add a second
    // USB-C once a Thunderbolt dock is plugged in).
    {
        name: 'MacBook Pro (14"/16")',
        type: 'Laptop',
        category: 'computer',
        manufacturer: 'Apple',
        inputs: [
            {
                name: 'Headphone',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
                notes: 'high-impedance headphone out',
            },
        ],
        outputs: [
            {
                name: 'USB-C / Thunderbolt 1',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'USB-C / Thunderbolt 2',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'USB-C / Thunderbolt 3',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'HDMI',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'HDMI',
            },
        ],
    },
    {
        name: 'MacBook Air (M-series)',
        type: 'Laptop',
        category: 'computer',
        manufacturer: 'Apple',
        inputs: [
            {
                name: 'Headphone',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
        ],
        outputs: [
            {
                name: 'USB-C / Thunderbolt 1',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'USB-C / Thunderbolt 2',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
    },
    {
        name: 'Mac mini (M-series)',
        type: 'Desktop',
        category: 'computer',
        manufacturer: 'Apple',
        inputs: [
            {
                name: 'Headphone',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
        ],
        outputs: [
            {
                name: 'USB-C / Thunderbolt 1',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'USB-C / Thunderbolt 2',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'USB-A 1',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A 2',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'HDMI',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'HDMI',
            },
            {
                name: 'Ethernet',
                type: 'output',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                bidirectional: true,
            },
        ],
    },
    {
        name: 'Windows laptop (typical)',
        type: 'Laptop',
        category: 'computer',
        manufacturer: 'Generic',
        inputs: [
            {
                name: 'Mic / headset',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRRS',
            },
        ],
        outputs: [
            {
                name: 'USB-C',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'USB-A 1',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A 2',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'HDMI',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'HDMI',
            },
        ],
    },
    {
        name: 'Desktop PC (tower)',
        type: 'Desktop',
        category: 'computer',
        manufacturer: 'Generic',
        inputs: [
            {
                name: 'Line in (rear)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Mic in (rear)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
        ],
        outputs: [
            {
                name: 'Line out (rear)',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'USB-A rear 1',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A rear 2',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A rear 3',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A rear 4',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-C rear',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
            {
                name: 'USB-A front 1',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A front 2',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'HDMI',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'HDMI',
            },
            {
                name: 'Ethernet',
                type: 'output',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                bidirectional: true,
            },
        ],
    },
    // ─────────────────────────────────────────────────────────────
    //  Wave 1 — industry-standard additions
    //
    //  Fills out the catalog with canonical, widely-recognised
    //  devices across every category. Port specs match the real
    //  hardware's back-panel layout as published on each
    //  manufacturer's spec sheet. Port counts are honest — e.g.
    //  SM58 has no XLR *input*, only an XLR output tail; the mic
    //  preset reflects that rather than inventing a "through"
    //  input that doesn't exist.
    // ─────────────────────────────────────────────────────────────
    // ── Microphones ────────────────────────────────────────────
    {
        name: 'Shure SM57',
        type: 'Dynamic Instrument Microphone',
        category: 'microphone',
        manufacturer: 'Shure',
        inputs: [],
        outputs: [
            {
                name: 'XLR Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced mono, dynamic, no phantom required',
            },
        ],
    },
    {
        name: 'Shure SM58',
        type: 'Dynamic Vocal Microphone',
        category: 'microphone',
        manufacturer: 'Shure',
        inputs: [],
        outputs: [
            {
                name: 'XLR Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced mono, dynamic, no phantom required',
            },
        ],
    },
    {
        name: 'Shure SM7B',
        type: 'Dynamic Broadcast Microphone',
        category: 'microphone',
        manufacturer: 'Shure',
        inputs: [],
        outputs: [
            {
                name: 'XLR Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced mono, dynamic — low output, typically wants a Cloudlifter or FetHead inline',
            },
        ],
    },
    {
        name: 'Shure Beta 52A',
        type: 'Dynamic Kick Drum Microphone',
        category: 'microphone',
        manufacturer: 'Shure',
        inputs: [],
        outputs: [
            {
                name: 'XLR Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced mono, supercardioid dynamic tuned for kick drum and bass cab',
            },
        ],
    },
    {
        name: 'Neumann U 87 Ai',
        type: 'Large-Diaphragm Condenser Microphone',
        category: 'microphone',
        manufacturer: 'Neumann',
        inputs: [],
        outputs: [
            {
                name: 'XLR Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced mono, condenser — requires +48V phantom power',
            },
        ],
    },
    {
        name: 'AKG C414 XLS',
        type: 'Large-Diaphragm Condenser Microphone',
        category: 'microphone',
        manufacturer: 'AKG',
        inputs: [],
        outputs: [
            {
                name: 'XLR Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced mono, multi-pattern condenser — requires +48V phantom',
            },
        ],
    },
    {
        name: 'Audio-Technica AT2020',
        type: 'Cardioid Condenser Microphone',
        category: 'microphone',
        manufacturer: 'Audio-Technica',
        inputs: [],
        outputs: [
            {
                name: 'XLR Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced mono, cardioid condenser — requires +48V phantom',
            },
        ],
    },
    {
        name: 'Rode NT1 5th Gen',
        type: 'Cardioid Condenser Microphone',
        category: 'microphone',
        manufacturer: 'Rode',
        inputs: [
            {
                name: 'USB-C',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'dual-output: built-in USB interface on the 5th gen',
            },
        ],
        outputs: [
            {
                name: 'XLR Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced mono analog path — requires +48V phantom',
            },
        ],
    },
    // ── Audio Interfaces ────────────────────────────────────────
    {
        name: 'Universal Audio Apollo x8',
        type: 'Thunderbolt Audio Interface',
        category: 'interface',
        manufacturer: 'Universal Audio',
        inputs: [
            {
                name: 'Mic/Line 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
                notes: 'Unison preamp',
            },
            {
                name: 'Mic/Line 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
                notes: 'Unison preamp',
            },
            {
                name: 'Mic/Line 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
                notes: 'Unison preamp',
            },
            {
                name: 'Mic/Line 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
                notes: 'Unison preamp',
            },
            {
                name: 'Line In 5',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 6',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 7',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 8',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'ADAT In 1',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'ADAT In 2',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'Word Clock In',
                type: 'input',
                signalType: 'word_clock',
                connectorFormat: 'BNC',
            },
        ],
        outputs: [
            {
                name: 'Monitor Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Monitor Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 5',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 6',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 7',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 8',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'ADAT Out 1',
                type: 'output',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'ADAT Out 2',
                type: 'output',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'Word Clock Out',
                type: 'output',
                signalType: 'word_clock',
                connectorFormat: 'BNC',
            },
            {
                name: 'Thunderbolt 3',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
    },
    {
        name: 'Focusrite Scarlett 4i4 4th Gen',
        type: 'USB Audio Interface',
        category: 'interface',
        manufacturer: 'Focusrite',
        inputs: [
            {
                name: 'Mic/Line/Inst 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line/Inst 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Line In 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
        outputs: [
            {
                name: 'Monitor Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Monitor Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB-C',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
    },
    {
        name: 'Focusrite Scarlett 18i20 4th Gen',
        type: 'USB Audio Interface',
        category: 'interface',
        manufacturer: 'Focusrite',
        inputs: [
            {
                name: 'Mic/Line 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 5',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 6',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 7',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Line 8',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'ADAT In 1',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'ADAT In 2',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'S/PDIF In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Word Clock In',
                type: 'input',
                signalType: 'word_clock',
                connectorFormat: 'BNC',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
        outputs: [
            {
                name: 'Monitor Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Monitor Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 5',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 6',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 7',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 8',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 9',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 10',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'ADAT Out 1',
                type: 'output',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'ADAT Out 2',
                type: 'output',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'S/PDIF Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Word Clock Out',
                type: 'output',
                signalType: 'word_clock',
                connectorFormat: 'BNC',
            },
            {
                name: 'Headphone 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB-C',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
    },
    {
        name: 'RME Babyface Pro FS',
        type: 'USB Audio Interface',
        category: 'interface',
        manufacturer: 'RME',
        inputs: [
            {
                name: 'XLR Mic 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'XLR Mic 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Line/Inst 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line/Inst 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'ADAT In',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
                notes: 'via breakout cable',
            },
        ],
        outputs: [
            {
                name: 'Monitor Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Monitor Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out XLR L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Line Out XLR R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Headphone (1/4")',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone (3.5mm)',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'ADAT Out',
                type: 'output',
                signalType: 'adat',
                connectorFormat: 'optical',
                channels: 8,
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
                notes: 'via breakout cable',
            },
            {
                name: 'USB-C',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
    },
    {
        name: 'MOTU M4',
        type: 'USB Audio Interface',
        category: 'interface',
        manufacturer: 'MOTU',
        inputs: [
            {
                name: 'Mic/Inst 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic/Inst 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Line In 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line In 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
        ],
        outputs: [
            {
                name: 'Main Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Main Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Line Out 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'USB-C',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
    },
    // ── Mixers ───────────────────────────────────────────────
    {
        name: 'Mackie ProFX12v3',
        type: 'Analog Mixer with USB',
        category: 'mixer',
        manufacturer: 'Mackie',
        inputs: [
            {
                name: 'CH 1 Mic/Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 2 Mic/Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 3 Mic/Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 4 Mic/Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 5/6 Stereo L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CH 5/6 Stereo R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CH 7/8 Stereo L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CH 7/8 Stereo R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Return L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Return R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
        ],
        outputs: [
            {
                name: 'Main Out XLR L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Main Out XLR R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Main Out TRS L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Main Out TRS R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'USB',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
                notes: 'stereo USB out + 2-in return',
            },
        ],
    },
    {
        name: 'Allen & Heath ZEDi-10FX',
        type: 'Analog Mixer with USB + FX',
        category: 'mixer',
        manufacturer: 'Allen & Heath',
        inputs: [
            {
                name: 'CH 1 Mic/Hi-Z',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 2 Mic/Hi-Z',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 3 Mic',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'CH 4 Mic',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'CH 5/6 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CH 5/6 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CH 7/8 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CH 7/8 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
        ],
        outputs: [
            {
                name: 'Main Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Main Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'USB',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
                notes: 'stereo USB in/out',
            },
        ],
    },
    {
        name: 'Yamaha MG10XU',
        type: 'Analog Mixer with USB + FX',
        category: 'mixer',
        manufacturer: 'Yamaha',
        inputs: [
            {
                name: 'CH 1 Mic/Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 2 Mic/Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 3 Mic/Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 4 Mic/Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 5/6 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CH 5/6 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CH 7/8 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CH 7/8 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'CH 9/10 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'CH 9/10 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
        ],
        outputs: [
            {
                name: 'Stereo Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Stereo Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Monitor Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Monitor Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Send 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'USB',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
    },
    // ── Monitoring ─────────────────────────────────────────────
    {
        name: 'Genelec 8030C',
        type: 'Studio Monitor (Active)',
        category: 'monitoring',
        manufacturer: 'Genelec',
        inputs: [
            {
                name: 'Audio In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
                notes: 'balanced mono — one monitor = one channel',
            },
        ],
        outputs: [],
    },
    {
        name: 'Yamaha HS8',
        type: 'Studio Monitor (Active)',
        category: 'monitoring',
        manufacturer: 'Yamaha',
        inputs: [
            {
                name: 'XLR In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
                exclusiveGroup: 'input',
                notes: 'balanced mono',
            },
            {
                name: 'TRS In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                exclusiveGroup: 'input',
                notes: 'balanced mono',
            },
        ],
        outputs: [],
    },
    {
        name: 'Adam Audio A7V',
        type: 'Studio Monitor (Active)',
        category: 'monitoring',
        manufacturer: 'Adam Audio',
        inputs: [
            {
                name: 'XLR In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
                exclusiveGroup: 'input',
            },
            {
                name: 'RCA In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
                exclusiveGroup: 'input',
            },
        ],
        outputs: [],
    },
    {
        name: 'KRK Rokit 5 G4',
        type: 'Studio Monitor (Active)',
        category: 'monitoring',
        manufacturer: 'KRK',
        inputs: [
            {
                name: 'XLR In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
                exclusiveGroup: 'input',
            },
            {
                name: 'TRS In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
                exclusiveGroup: 'input',
            },
            {
                name: 'RCA In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
                exclusiveGroup: 'input',
            },
        ],
        outputs: [],
    },
    // ── Synths ────────────────────────────────────────────────
    {
        name: 'Moog Subsequent 37',
        type: 'Analog Monosynth',
        category: 'synth',
        manufacturer: 'Moog',
        inputs: [
            {
                name: 'Ext Audio In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'CV In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Gate In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Sustain In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Audio Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    {
        name: 'Sequential Prophet-5 Rev 4',
        type: 'Analog Polysynth',
        category: 'synth',
        manufacturer: 'Sequential',
        inputs: [
            {
                name: 'Pedal/CV 1',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Pedal/CV 2',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Sustain',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
                notes: 'unbalanced',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
                notes: 'unbalanced',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    {
        name: 'Korg Minilogue XD',
        type: 'Analog Polysynth',
        category: 'synth',
        manufacturer: 'Korg',
        inputs: [
            {
                name: 'Audio In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV In 1',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV In 2',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Damper',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    {
        name: 'Arturia MiniFreak',
        type: 'Hybrid Digital/Analog Synth',
        category: 'synth',
        manufacturer: 'Arturia',
        inputs: [
            {
                name: 'Sustain',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Expression',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Gate In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Gate Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
        ],
    },
    // ── Drum Machines ─────────────────────────────────────────
    {
        name: 'Elektron Digitakt II',
        type: 'Drum Machine / Sampler',
        category: 'drum_machine',
        manufacturer: 'Elektron',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Main Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Main Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    {
        name: 'Akai MPC Live II',
        type: 'Standalone Drum Machine / DAW',
        category: 'drum_machine',
        manufacturer: 'Akai',
        inputs: [
            {
                name: 'Input 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Input 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A via adapter',
            },
            {
                name: 'USB-A 1',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
                notes: 'USB host — for class-compliant MIDI controllers',
            },
            {
                name: 'USB-A 2',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-B',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
                notes: 'class-compliant device mode to computer',
            },
        ],
        outputs: [
            {
                name: 'Main Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Main Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Out 3',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Out 4',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Out 5',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Out 6',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    {
        name: 'Arturia DrumBrute Impact',
        type: 'Analog Drum Machine',
        category: 'drum_machine',
        manufacturer: 'Arturia',
        inputs: [
            {
                name: 'Sync In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Mix Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Kick Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Snare Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Hi Tom Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Lo Tom Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Cymbal Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Cow/FM Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Closed Hat Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Open Hat Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Sync Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // ── Controllers ────────────────────────────────────────────
    {
        name: 'Akai MPK Mini MK3',
        type: 'USB MIDI Controller',
        category: 'controller',
        manufacturer: 'Akai',
        inputs: [
            {
                name: 'Sustain',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [],
    },
    {
        name: 'Novation Launchkey 49 MK3',
        type: 'USB MIDI Controller',
        category: 'controller',
        manufacturer: 'Novation',
        inputs: [
            {
                name: 'Sustain',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
        ],
    },
    {
        name: 'Native Instruments Komplete Kontrol S49 MK3',
        type: 'USB MIDI Controller',
        category: 'controller',
        manufacturer: 'Native Instruments',
        inputs: [
            {
                name: 'Pedal/Sustain 1',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Pedal/Sustain 2',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // ── Semi-Modular ──────────────────────────────────────────
    {
        name: 'Moog Mother-32',
        type: 'Semi-Modular Analog Synth',
        category: 'semi_modular',
        manufacturer: 'Moog',
        inputs: [
            {
                name: 'Ext Audio In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VCO Exp',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VCO Lin FM',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VCF Cutoff',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VCA CV',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Mix CV',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Mult 1',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Mult 2',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Assign CV',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Tempo In',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
        outputs: [
            {
                name: 'VCO Saw',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VCO Pulse',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Noise',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VCA Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VC Mix Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'KB',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Gate',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Assign Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Tempo Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Audio Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    {
        name: 'Make Noise 0-Coast',
        type: 'Semi-Modular Analog Synth',
        category: 'semi_modular',
        manufacturer: 'Make Noise',
        inputs: [
            {
                name: 'Clock',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Tempo',
                type: 'input',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Pitch CV',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Strum',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
            {
                name: 'MIDI USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Line Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Overtone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Multiply',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Balance',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Tempo Out',
                type: 'output',
                signalType: 'sync',
                connectorFormat: '3.5mm TS',
            },
        ],
    },
    // ── Groovebox ──────────────────────────────────────────────
    {
        name: 'Elektron Digitone II',
        type: 'FM Groovebox',
        category: 'groovebox',
        manufacturer: 'Elektron',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Main Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Main Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    {
        name: 'Polyend Tracker+',
        type: 'Tracker-Style Groovebox',
        category: 'groovebox',
        manufacturer: 'Polyend',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Main Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Main Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '3.5mm TRS',
                notes: 'Type A',
            },
        ],
    },
    // ── Sampler ────────────────────────────────────────────────
    {
        name: 'Elektron Octatrack MKII',
        type: 'Performance Sampler',
        category: 'sampler',
        manufacturer: 'Elektron',
        inputs: [
            {
                name: 'Input AB L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Input AB R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Input CD L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Input CD R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
        outputs: [
            {
                name: 'Main Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Main Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Cue Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Cue Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // ── Effects ────────────────────────────────────────────────
    {
        name: 'Strymon BigSky',
        type: 'Reverb Pedal',
        category: 'effects',
        manufacturer: 'Strymon',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Expression',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    {
        name: 'Strymon TimeLine',
        type: 'Delay Pedal',
        category: 'effects',
        manufacturer: 'Strymon',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Expression',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // ── Recorder ───────────────────────────────────────────────
    {
        name: 'Zoom H6',
        type: 'Handheld Recorder',
        category: 'recorder',
        manufacturer: 'Zoom',
        inputs: [
            {
                name: 'CH 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 3',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 4',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
        ],
        outputs: [
            {
                name: 'Line Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Line Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'USB',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
                notes: 'mass-storage mode + audio interface mode',
            },
        ],
    },
    {
        name: 'Zoom F3',
        type: 'Field Recorder (32-bit float)',
        category: 'recorder',
        manufacturer: 'Zoom',
        inputs: [
            {
                name: 'CH 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'CH 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
        ],
        outputs: [
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'USB',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
    },
    {
        name: 'Tascam DR-40X',
        type: 'Handheld Recorder',
        category: 'recorder',
        manufacturer: 'Tascam',
        inputs: [
            {
                name: 'CH 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'CH 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
        ],
        outputs: [
            {
                name: 'Line Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Line Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
            {
                name: 'USB',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-C',
                bidirectional: true,
            },
        ],
    },
    // ── USB Hub / Network Switch ────────────────────────────────
    {
        name: 'Anker 7-Port USB 3.0 Hub',
        type: 'Powered USB Hub',
        category: 'usb_hub',
        manufacturer: 'Anker',
        inputs: [
            {
                name: 'USB-B (to host)',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'USB-A 1',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A 2',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A 3',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A 4',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A 5',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A 6',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
            {
                name: 'USB-A 7',
                type: 'output',
                signalType: 'usb',
                connectorFormat: 'USB-A',
                bidirectional: true,
            },
        ],
    },
    {
        name: 'Netgear GS308 8-Port Gigabit Switch',
        type: 'Unmanaged Network Switch',
        category: 'network_switch',
        manufacturer: 'Netgear',
        inputs: [
            {
                name: 'Ethernet 1',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                bidirectional: true,
            },
            {
                name: 'Ethernet 2',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                bidirectional: true,
            },
            {
                name: 'Ethernet 3',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                bidirectional: true,
            },
            {
                name: 'Ethernet 4',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                bidirectional: true,
            },
            {
                name: 'Ethernet 5',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                bidirectional: true,
            },
            {
                name: 'Ethernet 6',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                bidirectional: true,
            },
            {
                name: 'Ethernet 7',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                bidirectional: true,
            },
            {
                name: 'Ethernet 8',
                type: 'input',
                signalType: 'ethernet',
                connectorFormat: 'RJ45',
                bidirectional: true,
            },
        ],
        outputs: [],
    },
    // ── MIDI Interface ─────────────────────────────────────────
    {
        name: 'MOTU Micro Express USB',
        type: 'USB MIDI Interface',
        category: 'midi_interface',
        manufacturer: 'MOTU',
        inputs: [
            {
                name: 'MIDI In 1',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 2',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 3',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI In 4',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'MIDI Out 1',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 2',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 3',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 4',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 5',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Out 6',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
    // ── Guitar / stereo FX pedals ─────────────────────────────
    {
        name: 'Strymon TimeLine',
        type: 'Stereo Delay Pedal',
        category: 'effects',
        manufacturer: 'Strymon',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Expression In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '1/4" TRS-MIDI',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '1/4" TRS-MIDI',
            },
        ],
    },
    {
        name: 'Strymon BigSky',
        type: 'Stereo Reverb Pedal',
        category: 'effects',
        manufacturer: 'Strymon',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Expression In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '1/4" TRS-MIDI',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '1/4" TRS-MIDI',
            },
        ],
    },
    {
        name: 'Electro-Harmonix POG 3',
        type: 'Polyphonic Octave Pedal',
        category: 'effects',
        manufacturer: 'Electro-Harmonix',
        inputs: [
            {
                name: 'Audio In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Expression In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TRS',
            },
        ],
        outputs: [
            {
                name: 'Dry Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Effect Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
        ],
    },
    {
        name: 'Chase Bliss Mood MKII',
        type: 'Micro-Looper / Reverb / Delay',
        category: 'effects',
        manufacturer: 'Chase Bliss Audio',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'CV In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '1/4" TRS-MIDI',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
        ],
    },
    // ── Modular synth modules ─────────────────────────────────
    {
        name: 'Make Noise Maths',
        type: 'Eurorack Function Generator',
        category: 'semi_modular',
        manufacturer: 'Make Noise',
        inputs: [
            {
                name: 'Ch1 Signal In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Ch1 Trig In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Ch4 Signal In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Ch4 Trig In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
        ],
        outputs: [
            {
                name: 'Ch1 Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Ch2 Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Ch3 Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Ch4 Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Unity Sum',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Inverted Sum',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
        ],
    },
    {
        name: 'Mutable Instruments Plaits',
        type: 'Eurorack Macro Oscillator',
        category: 'semi_modular',
        manufacturer: 'Mutable Instruments',
        inputs: [
            {
                name: 'V/Oct In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Trigger In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Level In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Timbre CV',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Morph CV',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Harmonics CV',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
        ],
        outputs: [
            {
                name: 'Main Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Aux Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
        ],
    },
    {
        name: 'Intellijel Metropolix',
        type: 'Eurorack Sequencer',
        category: 'semi_modular',
        manufacturer: 'Intellijel',
        inputs: [
            {
                name: 'Clock In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Reset In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Run In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV In A',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'CV In B',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
        ],
        outputs: [
            {
                name: 'Pitch A',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Gate A',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Pitch B',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Gate B',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Aux 1',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'Aux 2',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
        ],
    },
    {
        name: 'Moog Mother-32',
        type: 'Semi-Modular Synthesizer',
        category: 'semi_modular',
        manufacturer: 'Moog',
        inputs: [
            {
                name: 'Ext Audio In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'KB CV In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'KB Gate In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VCO Exp In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VCF Cut In',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
        ],
        outputs: [
            {
                name: 'Audio Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Headphone',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'VCO Tri',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VCO Saw',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'VCA CV',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
            {
                name: 'EG Out',
                type: 'output',
                signalType: 'cv_gate',
                connectorFormat: '3.5mm TS',
            },
        ],
    },
    // ── Studio outboard (rackmount FX / dynamics) ─────────────
    {
        name: 'Eventide H9000',
        type: 'Rackmount Multi-Effects Processor',
        category: 'effects',
        manufacturer: 'Eventide',
        inputs: [
            {
                name: 'Analog In 1 (XLR/TRS)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Analog In 2 (XLR/TRS)',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'AES/EBU In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'ADAT In A',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'TOSLINK',
            },
            {
                name: 'ADAT In B',
                type: 'input',
                signalType: 'adat',
                connectorFormat: 'TOSLINK',
            },
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'Word Clock In',
                type: 'input',
                signalType: 'word_clock',
                connectorFormat: 'BNC',
            },
        ],
        outputs: [
            {
                name: 'Analog Out 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Analog Out 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'AES/EBU Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'ADAT Out A',
                type: 'output',
                signalType: 'adat',
                connectorFormat: 'TOSLINK',
            },
            {
                name: 'ADAT Out B',
                type: 'output',
                signalType: 'adat',
                connectorFormat: 'TOSLINK',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'Word Clock Out',
                type: 'output',
                signalType: 'word_clock',
                connectorFormat: 'BNC',
            },
        ],
    },
    {
        name: 'Universal Audio LA-610 MkII',
        type: 'Tube Channel Strip',
        category: 'effects',
        manufacturer: 'Universal Audio',
        inputs: [
            {
                name: 'Mic In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Line In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Hi-Z In',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
        ],
        outputs: [
            {
                name: 'Line Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'TRS Out',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
        ],
    },
    {
        name: 'API 2500 Bus Compressor',
        type: 'Stereo Bus Compressor',
        category: 'effects',
        manufacturer: 'API',
        inputs: [
            {
                name: 'Audio In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Audio In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Sidechain In L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Sidechain In R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
        ],
        outputs: [
            {
                name: 'Audio Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Audio Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
        ],
    },
    // ── DJ mixers ────────────────────────────────────────────
    {
        name: 'Pioneer DJ DJM-A9',
        type: '4-Channel Professional DJ Mixer',
        category: 'mixer',
        manufacturer: 'Pioneer DJ',
        inputs: [
            {
                name: 'Ch1 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch1 Phono',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch2 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch2 Phono',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch3 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch3 Digital',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'Coaxial',
            },
            {
                name: 'Ch4 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch4 Digital',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'Coaxial',
            },
            {
                name: 'Mic 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Return L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Return R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'USB A',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
            {
                name: 'USB B',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Master Out XLR L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Master Out XLR R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Master Out TRS L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Master Out TRS R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Booth L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Booth R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Rec Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Rec Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Send L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Send R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphones 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphones 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    {
        name: 'Allen & Heath Xone:96',
        type: '6-Channel Analog/Digital DJ Mixer',
        category: 'mixer',
        manufacturer: 'Allen & Heath',
        inputs: [
            {
                name: 'Ch1 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch1 Phono',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch2 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch2 Phono',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch3 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch3 Phono',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch4 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch4 Phono',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch5 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch6 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Mic 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Return 1 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Return 1 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Return 2 L',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Return 2 R',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'USB Audio',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Master XLR L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Master XLR R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Master RCA L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Master RCA R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Booth L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Booth R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Send 1 L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Send 1 R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Send 2 L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Send 2 R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Record L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Record R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Headphones 1',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Headphones 2',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '3.5mm TRS',
            },
        ],
    },
    {
        name: 'Rane Seventy-Two MKII',
        type: '2-Channel Battle DJ Mixer',
        category: 'mixer',
        manufacturer: 'Rane',
        inputs: [
            {
                name: 'Ch1 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch1 Phono',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch2 Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Ch2 Phono',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Mic 1',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'combo XLR/TRS',
            },
            {
                name: 'Mic 2',
                type: 'input',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Aux Line',
                type: 'input',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Master XLR L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Master XLR R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'XLR',
            },
            {
                name: 'Booth L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Booth R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Session L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Session R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: 'RCA',
            },
            {
                name: 'Headphones',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
        ],
    },
    // ── Poly synth / vocoder ──────────────────────────────────
    {
        name: 'Sequential Prophet-6',
        type: '6-Voice Analog Polysynth',
        category: 'synth',
        manufacturer: 'Sequential',
        inputs: [
            {
                name: 'MIDI In',
                type: 'input',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'Sustain Pedal',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'Volume Pedal',
                type: 'input',
                signalType: 'cv_gate',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'USB',
                type: 'input',
                signalType: 'usb',
                connectorFormat: 'USB-B',
                bidirectional: true,
            },
        ],
        outputs: [
            {
                name: 'Main Out L',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Main Out R',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TS',
            },
            {
                name: 'Headphones',
                type: 'output',
                signalType: 'audio',
                connectorFormat: '1/4" TRS',
            },
            {
                name: 'MIDI Out',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
            {
                name: 'MIDI Thru',
                type: 'output',
                signalType: 'midi',
                connectorFormat: '5-pin DIN',
            },
        ],
    },
];
//# sourceMappingURL=devicePresets.js.map